/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FilterCriteriaInfo,
  ReferentialItemDto,
  SiegeLieuSuiviGridDtoPaginatedResults,
  SiegeLieuSuiviSearchGlobal,
} from '../models/index';
import {
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoToJSON,
    SiegeLieuSuiviGridDtoPaginatedResultsFromJSON,
    SiegeLieuSuiviGridDtoPaginatedResultsToJSON,
    SiegeLieuSuiviSearchGlobalFromJSON,
    SiegeLieuSuiviSearchGlobalToJSON,
} from '../models/index';

export interface SuiviSiegeLieuBaseSearchRequest {
    SiegeLieuSuiviSearchGlobal?: SiegeLieuSuiviSearchGlobal;
}

export interface SuiviSiegeLieuGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface SuiviSiegeLieuGetSelectItemsRequest {
    searchField: string;
}

/**
 * 
 */
export class SuiviSiegeLieuApi extends runtime.BaseAPI {

    /**
     */
    async suiviSiegeLieuBaseSearchRaw(requestParameters: SuiviSiegeLieuBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiegeLieuSuiviGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/SuiviSiegeLieu/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SiegeLieuSuiviSearchGlobalToJSON(requestParameters.SiegeLieuSuiviSearchGlobal),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiegeLieuSuiviGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async suiviSiegeLieuBaseSearch(requestParameters: SuiviSiegeLieuBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiegeLieuSuiviGridDtoPaginatedResults> {
        const response = await this.suiviSiegeLieuBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async suiviSiegeLieuGetSearchCriteriasRaw(requestParameters: SuiviSiegeLieuGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/SuiviSiegeLieu/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async suiviSiegeLieuGetSearchCriterias(requestParameters: SuiviSiegeLieuGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.suiviSiegeLieuGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async suiviSiegeLieuGetSelectItemsRaw(requestParameters: SuiviSiegeLieuGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReferentialItemDto>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling suiviSiegeLieuGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/SuiviSiegeLieu/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReferentialItemDtoFromJSON));
    }

    /**
     */
    async suiviSiegeLieuGetSelectItems(requestParameters: SuiviSiegeLieuGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReferentialItemDto>> {
        const response = await this.suiviSiegeLieuGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
